import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Define a type for the slice state
export interface PortalState {
  payment: {
    opayo: {
      merchantSessionKey: {
        data: {
          key: string;
          expiry: string;
        } | null;
        loading: boolean;
        errors: string[];
      };
    };
  };
}

// Define the initial state using that type
const initialState: PortalState = {
  payment: {
    opayo: {
      merchantSessionKey: {
        data: null,
        loading: false,
        errors: [],
      },
    },
  },
};

//////////////////////////////
//////// Async Thunks ////////
//////////////////////////////

// Create Opayo merchant session key
export const createOpayoMerchantSessionKey = createAsyncThunk(
  "portal/payment/opayo/merchant-session-key/get",
  async (
    obj: {
      propertyId: string | undefined;
    },
    { getState, rejectWithValue },
  ) => {
    try {
      // Retrieve auth data
      let res = await axios.get(`/api/payment/opayo/merchant-session-key/${obj.propertyId}/`);
      return { data: res.data, status: res.status };
    } catch (err: any) {
      if (err.response && err.response.data.message) {
        return rejectWithValue(err.response.data.message);
      } else {
        return rejectWithValue(err.message);
      }
    }
  },
);

/////////////////////////////
//////// Redux slice ////////
/////////////////////////////

const portalSlice = createSlice({
  name: "portal",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      // Opayo merchant session key
      .addCase(createOpayoMerchantSessionKey.pending, (state, action) => {
        state.payment.opayo.merchantSessionKey.loading = true;
      })
      .addCase(createOpayoMerchantSessionKey.fulfilled, (state, action) => {
        state.payment.opayo.merchantSessionKey.loading = false;
        state.payment.opayo.merchantSessionKey.data = action.payload.data;
      })
      .addCase(createOpayoMerchantSessionKey.rejected, (state, action) => {
        state.payment.opayo.merchantSessionKey.loading = false;
        state.payment.opayo.merchantSessionKey.errors.push(action.payload as string);
      });
  },
});

export default portalSlice.reducer;
